import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpUrgentBatchPage } from '@/features/pcmp/pages/PcmpUrgentBatchPage';
import { pcmpUrgentBatchSearchSchema } from '@/features/pcmp/types/pcmpRequest.types';

export const Route = createFileRoute('/_auth/pcmp/requests/batches/$batchNo/')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  validateSearch: pcmpUrgentBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Urgent Batch">
      <Suspense fallback={<PageLoader />}>
        <PcmpUrgentBatchPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
